import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, from, map, of } from 'rxjs';
import { calcResizedUrlFromUuid } from '../../lib/calc-resized-url';
import { PICFLOW_CONFIG } from '../../picflow-config';
import { GalleryService } from '../../services/gallery.service';

export const publicGalleryPageImageUrlResolver: ResolveFn<string> = route => {
  const config = inject(PICFLOW_CONFIG);
  const galleryService = inject(GalleryService);

  return from(galleryService.getPublicGalleryFromSnapshot(route)).pipe(
    map(gallery => {
      if (!gallery?.teaser?.uuid) return;
      return calcResizedUrlFromUuid(config.assetsEndpoint, gallery.teaser.uuid, `1200x630`);
    }),
    catchError(() => of(undefined as string))
  );
};
